import React, { useMemo, useCallback, useRef, Fragment } from 'react';

import { useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';

import { Visibility } from '@material-ui/icons';

import { number } from '~/helpers';
import { UnidataTable, Modal } from '~/components';
import { recordFiltering } from '~/store/modules/notasFiscaisRecebidas/actions';

import { Toolbar, Details } from './components';

export default function NotasFiscaisRecebidas() {
  const data = useSelector((state) => state.notasfiscaisrecebidas);
  const modalRef = useRef(null);

  const buttons = useMemo(
    () => [
      {
        label: 'Fechar',
        color: 'primary',
        variant: 'container',
        autoFocus: true,
        callback: () => modalRef.current.handleCloseModal(),
      },
    ],
    []
  );

  const status = useMemo(
    () => [
      { value: 'AGUARDANDO RECEBIMENTO ', label: 0 },
      { value: 'RECEBIMENTO INICIADO', label: 1 },
      { value: 'RECEBIMENTO FINALIZADO', label: 2 },
      { value: 'CANCELADA', label: 3 },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'nfre_data_recebimento_inicial',
        label: 'Data Recebimento (Inicio)',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: { type: 'initialdatetime' },
      },
      {
        id: 'nfre_data_recebimento_final',
        label: 'Data Recebimento (Final)',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: { type: 'finaldatetime' },
      },
      { id: 'nfre_numero', label: 'Número', filter: { type: 'string' } },
      {
        id: 'nfre_status',
        label: 'Status',
        formatted: (v) => status.find((s) => s.label === v).value || v,
        filter: { type: 'select', options: status },
      },

      {
        id: 'nfre_data_ultimo_status',
        label: 'Data Último Status',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },

      { id: 'post_desc', label: 'Posto', filter: { type: 'string' } },

      { id: 'desc_placa_ct', label: 'Placa', filter: { type: 'string' } },
      {
        id: 'desc_distribuidora',
        label: 'CNPJ Distribuidora',
        filter: { type: 'string' },
      },
      {
        id: 'desc_volume_nf',
        label: 'Volume NF',
        formatted: (value) => number(value, 0),
      },
      {
        id: 'desc_dt_emissao_nf',
        label: 'Data Emissão NF',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      { id: 'nfre_chave', label: 'Chave Acesso', filter: { type: 'string' } },

      
      {
        id: 'nfre_from',
        label: 'From',
        filter: { type: 'string' },
      },

      {
        id: 'nfre_arquivo',
        label: 'Arquivo',
        filter: { type: 'string' },
      },      

    ],
    []
  );

  const handleOpenModal = useCallback((row) => {
    modalRef.current.handleOpenModal({ data: row });
  }, []);

  const actions = useMemo(
    () => [
      {
        title: 'Exibir Detalhe',
        color: 'default',
        icon: <Visibility />,
        action: handleOpenModal,
      },
    ],
    []
  );

  return (
    <Fragment>
      <UnidataTable
        fixed
        header={header}
        read={recordFiltering}
        redux={data}
        actions={actions}
        toolbar={Toolbar}
        title="NF Recebidas"
        keys={['nfre_numero', 'desc_distribuidora']}
        detach="nfre_numero"
      />

      <Modal
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        actions={buttons}
        title="NF Recebidas"
        component={Details}
      />
    </Fragment>
  );
}
